module.exports = __webpack_public_path__ + "static/media/Encomienda_Regular_480x480px.e20ca2ac.jpg";